import { highlightText } from '~/shared/lib/highlight-text'
import { Text } from '~/shared/ui'
import type { ClusterEventProps } from '../../model'

export function ClusterEvent({
  event,
  searchQuery,
}: {
  event: ClusterEventProps
  searchQuery: string
}) {
  return (
    <div className="flex flex-col gap-0.5 py-[3px]">
      <Text appearance="SUBTITLE2">{highlightText(event.title, searchQuery)}</Text>
      {event.subjectPersonCount != null && (
        <Text
          className="text-text-secondary"
          appearance="BODY2"
        >
          {highlightText(`Subject persons: ${String(event.subjectPersonCount)}`, searchQuery)}
        </Text>
      )}
      {event.subjectPersons && event.subjectPersons.length > 0 && (
        <div className="border-border-secondary mt-1 flex flex-col gap-0.5 border-l pl-2">
          {event.subjectPersons.map((person, idx) => {
            const name = [person.firstName, person.lastName].filter(Boolean).join(' ')
            return (
              <div
                key={idx}
                className="flex flex-col"
              >
                {name && <Text appearance="BODY2">{highlightText(name, searchQuery)}</Text>}
                {person.description && (
                  <Text
                    className="text-text-secondary"
                    appearance="CAPTION"
                  >
                    {highlightText(person.description, searchQuery)}
                  </Text>
                )}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
